import { Skill } from "../types";

type SkillsType = Skill[];

export const SkillsData: SkillsType = [
  {
    id: 1,
    title: "Scientist",
    tagline: "Rigor. Insight. Discovery.",
    description:
      "We all progress faster with the benefit of a trusted and insightful voice.",
  },
  {
    id: 2,
    title: "Mentor",
    tagline: "Developing. Nurturing. Coaching.",
    description:
      "We all progress faster with the benefit of a trusted and insightful voice.",
  },
  {
    id: 3,
    title: "Seller",
    tagline: "Commitments. Delivery. Results. Relationships.",
    description:
      "The right proposition, at the right time, helps both parties. Relationships matter so I always take the long view.",
  },
  {
    id: 4,
    title: "Generalist",
    tagline: "Mastering mastery. Business, science, style and humanity.",
    description:
      "Depth is important. Breadth is where I shine - I get deep enough to hold my own with experts in many fields.",
  },
  {
    id: 5,
    title: "Developer",
    tagline: "Structure. Correctness. Efficiency.",
    description:
      "Building quality software in teams is where I find satisfaction.",
  },
  {
    id: 6,
    title: "Planner",
    tagline: "Deliberate. Considered. Timely.",
    description:
      "Wasting time is wasting opportunity; having a great plan makes the most of our strengths.",
  },
  {
    id: 7,
    title: "Inventor",
    tagline: "Iteration. Perfection. Insight.",
    description:
      "People need new tools for new kinds of work. Everything can be improved. Count on me to find that better way.",
  },
  {
    id: 8,
    title: "Competitor",
    tagline: "Situational awareness. Tactics. Agility. Toughness.",
    description:
      "I play fair and I play to win. The other people are just as smart as me, but I know how to make the most of the cards I hold.",
  },
  {
    id: 9,
    title: "Organiser",
    tagline: "Neat, Planned, Accurate.",
    description:
      "Figuring out how to steer action in the most efficient and most repeatable way possible.",
  },
  {
    id: 10,
    title: "Designer",
    tagline: "Taste. Truth. Delight. Zen.",
    description:
      "I seek the sweet intersection of purpose, priority and presentation. I make complexity disappear.",
  },
  {
    id: 11,
    title: "Stalwart",
    tagline: "Solid. Productive. Gritty.",
    description:
      "There will be highs, there will be lows, but you can count on me to get things done and keep things moving regardless.",
  },
  {
    id: 12,
    title: "Entrepreneur",
    tagline: "Fortitude. Energy. Insight. Passion. Commerce.",
    description:
      "I love the business of science, the science of business, and the design of products and organizations.",
  },
  {
    id: 13,
    title: "Analyzer",
    tagline: "Data driven. Detailed. Sceptical.",
    description:
      "Understanding what's really going on, measuring and testing are where I ground my decisions.",
  },
  {
    id: 14,
    title: "Teacher",
    tagline: "Understanding. Insights. Growth.",
    description:
      "We manage, measure, trust and improve what we understand. Spreading knowledge benefits every team.",
  },
  {
    id: 15,
    title: "Leader",
    tagline: "Clarity. Mission. Direction.",
    description:
      "Big wins come to those who can rally their team to focus on something difficult. I earn their confidence and trust.",
  },
  {
    id: 16,
    title: "Technologist",
    tagline: "Current. Complex. Ahead.",
    description:
      "The future arrives in pieces; I like to know what they mean and how they work.",
  },
  {
    id: 17,
    title: "Manager",
    tagline: "Hiring. Feedback. Firing.",
    description:
      "Excellence comes from the whole team; balancing skills and requiring the utmost competence and commitment.",
  },
  {
    id: 18,
    title: "Tester",
    tagline: "Security specialist. Criminologist. Fiend. Bacon saver.",
    description:
      "I bring a proactive dose of cold hard reality, assessing the limits of design and implementation.",
  },
  {
    id: 19,
    title: "Contributor",
    tagline: "Generous. Open. Giving.",
    description:
      "We are part of a rising tide of open source because people have been willing to give ideas and work away. I want to be part of that.",
  },
  {
    id: 20,
    title: "Traveller",
    tagline: "Freedom. Exploration. Culture.",
    description:
      "It's a small world and I intend to see much of it. Have passport, will travel.",
  },
  {
    id: 21,
    title: "Helper",
    tagline: "Caring. Making a difference.",
    description:
      "Nobody is an expert in everything; sharing expertise and helping people over a hump makes all of us more effective.",
  },
  {
    id: 22,
    title: "Fixer",
    tagline: "Triage. Analysis. Experience.",
    description:
      "I shine when things go sideways in a complex environment. Count on me for correct root cause analysis and rapid, helpful corrective measures.",
  },
  {
    id: 23,
    title: "Problem Solver",
    tagline: "Determined. Constructive.",
    description:
      "Nothing of consequence goes perfectly smoothly. I like to handle tough situations effectively. I keep cool, I keep priorities clear, I find a way.",
  },
  {
    id: 24,
    title: "Conscience",
    tagline: "The means determine the ends.",
    description:
      "I am who I am because of how I treat others. Success is only satisfying when it's fairly won.",
  },
];
